<template>
  <!--   Main Content Start Here   -->
  <main>
    <div v-if="loader">
      <div class="spinner"></div>
    </div>
    <section class="dashboard_wraper">
      <div class="container_large">
        <div class="row">
          <!-- starting side bar -->
          <sidebar-component></sidebar-component>
          <!-- ending sidebar  -->
          <div class="col-md-12 col-lg-9">
            <div class="dashboard_card">
              <h2>Account Settings</h2>
              <div class="account_form">
                <form method="" action="" @submit.prevent="updateAccount()">
                  <div class="row">
                    <div
                      class="alert alert-success alert-dismissible"
                      v-if="
                        status &&
                        status.account_success &&
                        status.account_success == 200
                      "
                    >
                      <strong>Success!</strong> Action performed successfully.
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>First Name</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.first_name"
                          required
                        />
                        <v-errors :errors="errorFor('first_name')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Last Name</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.last_name"
                          required
                        />
                        <v-errors :errors="errorFor('last_name')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Email</label>
                        <input
                          type="email"
                          name=""
                          v-model="formObjAccount.email"
                          required
                        />
                        <v-errors :errors="errorFor('email')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Phone</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.phone"
                          required
                        />
                        <v-errors :errors="errorFor('phone')"></v-errors>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form_group">
                        <label>Address</label>
                        <input
                          type="text"
                          name=""
                          v-model="formObjAccount.address"
                        />
                        <v-errors :errors="errorFor('address')"></v-errors>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="order_buttons">
                      <input
                        type="submit"
                        class="button primary_button"
                        value="Update"
                      />
                    </div>
                  </div>
                  <hr />
                </form>
                <form @submit.prevent="updatePassword()">
                  <div class="update_password">
                    <h3>Update Password</h3>
                    <div class="row">
                      <div
                        class="alert alert-success alert-dismissible"
                        v-if="
                          status &&
                          status.password_success &&
                          status.password_success == 200
                        "
                      >
                        <strong>Success!</strong> Action performed successfully.
                      </div>
                      <div class="col-md-6">
                        <div class="form_group">
                          <label>Old Password</label>
                          <input
                            type="password"
                            name=""
                            v-model="formObjPassword.current_password"
                            required
                            placeholder="********"
                          />
                          <v-errors
                            :errors="errorFor('current_password')"
                          ></v-errors>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form_group">
                          <label>New Password</label>
                          <input
                            type="password"
                            name=""
                            v-model="formObjPassword.new_password"
                            required
                            placeholder="********"
                            @input="matchPassword()"
                          />
                          <transition-group name="fade" v-if="errors">
                            <p
                              v-for="(error, keyIndex) in errors"
                              :key="keyIndex + 'from'"
                            >
                              <span
                                v-if="error.password"
                                style="color: #b22222"
                                >{{ error.password }}</span
                              >
                            </p>
                          </transition-group>
                          <v-errors
                            :errors="errorFor('new_password')"
                          ></v-errors>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form_group">
                          <label>Confirm New Password</label>
                          <input
                            type="password"
                            name=""
                            v-model="formObjPassword.confirm_password"
                            required
                            placeholder="********"
                            @input="matchPassword()"
                          />
                          <transition-group name="fade" v-if="errors">
                            <p
                              v-for="(error, keyIndex) in errors"
                              :key="keyIndex + 'from'"
                            >
                              <span
                                v-if="error.password"
                                style="color: #b22222"
                                >{{ error.password }}</span
                              >
                            </p>
                          </transition-group>
                          <v-errors
                            :errors="errorFor('confirm_password')"
                          ></v-errors>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="order_buttons">
                          <input
                            type="submit"
                            class="button primary_button"
                            value="Update"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <!--   Main Content End Here   -->
</template>

<script>
import sidebarComponent from "./sidebar";
import { getCurrentUser } from "../../utils/auth";
import { is422 } from "../../utils/response";
import validationErrors from "../../mixins/validationErrors";
import usersApis from "../../Apis/users";

export default {
  mixins: [validationErrors],
  components: {
    sidebarComponent,
  },
  data() {
    return {
      loader: true,

      errors: null,
      status: null,

      formObjAccount: {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        address: null,
      },
      formObjPassword: {
        id: null,
        current_password: null,
        new_password: null,
        confirm_password: null,
      },
    };
  },
  methods: {
    // matching passwords
    matchPassword() {
      if (
        this.formObjPassword.new_password &&
        this.formObjPassword.confirm_password &&
        this.formObjPassword.new_password !=
          this.formObjPassword.confirm_password
      ) {
        this.errors = [{ password: "Password Does Match" }];
        return;
      } else {
        return (this.errors = null);
      }
    },
    async updateAccount() {
      const data = await usersApis
        .requestUsers("put", this.formObjAccount)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 204) {
            this.status = { account_success: 200 };
            localStorage.setItem("current_user", JSON.stringify(response.data));

            setTimeout(() => {
               this.status = null; 
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
          console.log(this.errors, this.status);
        })
        .then(() => {
          this.loader = false;
        });
    },
    updatePassword() {
      usersApis
        .updatePassword(this.formObjPassword.id, this.formObjPassword)
        .then((response) => {
          console.log(response);
          if (response.status == 200 || response.status == 204) {
            this.status = { password_success: 200 };

             setTimeout(() => {
               this.status = null; 
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          if (is422(error)) {
            this.errors = error.response.data.errors;
          }
          this.status =
            error.response && error.response.status
              ? error.response.status
              : "";
          console.log(this.errors, this.status);
        })
        .then(() => {
          this.loader = false;
        });
    },
  },
  created() {
    const user = getCurrentUser();
    this.formObjAccount = user;
    this.formObjPassword.id = user.id;
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/admin/admin-profile.vue